import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

interface SetAiDialogIsOpenOptions {
    onDialogClose?: () => void;
    /**
     * If true, will call the onDialogClose callback when the dialog is closed.
     * false is used when the dialog is closed by canceling the dialog.
     */
    callCloseCallback?: boolean | Event;
}

export class SetAiDialogIsOpen extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetAiDialogIsOpen';

    public constructor(public isOpen: boolean, public options: SetAiDialogIsOpenOptions = {}) {
        super(SetAiDialogIsOpen.ACTION_TYPE);

        if (options && (options instanceof Event || options.onDialogClose instanceof Event || options.callCloseCallback instanceof Event)) {
            this.options = {
                onDialogClose: null,
                callCloseCallback: false,
            };
        }
    }
}

const reducer = (state: StorymapState, action: SetAiDialogIsOpen): void => {
    state.aiDataDialogState.isAiDataDialogOpen = action.isOpen;

    if (action.isOpen === false && state.aiDataDialogState.onDialogClose && action.options.callCloseCallback) {
        state.aiDataDialogState.onDialogClose();
        state.aiDataDialogState.onDialogClose = null;
    }

    state.aiDataDialogState.onDialogClose = action.options.onDialogClose;
};

//@ts-ignore
registerReducer(SetAiDialogIsOpen.ACTION_TYPE, reducer);
